export const CurrentBidPanel = ({ auction, currentBid, minimumBid, iAmWinning }) => (
  <div className="mt-6 border border-[#E5E0D8] bg-white p-6">
    <p className="label-eyebrow text-[#555]">
      {auction.current_bid != null ? "Current bid" : "Starting price"}
    </p>
    <p className="font-mono-aam text-4xl text-[#1E3A8A] mt-2" data-testid="current-bid">
      ${currentBid.toLocaleString()}
    </p>
    <p className="text-sm text-[#555] mt-2">
      {auction.bid_count} bid{auction.bid_count === 1 ? "" : "s"} ·
      Min next bid <span className="font-mono-aam">${minimumBid.toLocaleString()}</span>
    </p>
    {iAmWinning && (
      <p className="mt-3 label-eyebrow text-[#F4C430] bg-[#1E3A8A] inline-block px-3 py-1.5">
        You are winning
      </p>
    )}
  </div>
);
